import { render, staticRenderFns } from "./CabinetMenu.vue?vue&type=template&id=294acfa1&scoped=true"
import script from "./CabinetMenu.vue?vue&type=script&lang=js"
export * from "./CabinetMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294acfa1",
  null
  
)

export default component.exports